import { Container, Row } from "reactstrap";
import { UserProfile, Users } from "../../../../constants";
import { Fragment } from "react/jsx-runtime";
import TextContent from "./TextContent";
import SinglePost from "./SinglePost";
import TwoGridPost from "./TwoGridPost";
import ListViewPost from "./ListViewPost";
import Breadcrumbs from "../../../../coreComponents/breadcrumbs";
import Profile from "./profile";

const UsersProfileContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={UserProfile} parent={Users} />
      <Container fluid>
        <div className="user-profile">
          <Row>
            <Profile />
            {/* <SinglePost />
            <TwoGridPost />
            <TextContent />
            <ListViewPost /> */}
          </Row>
        </div>
      </Container>
    </Fragment>
  );
};

export default UsersProfileContainer;
